const CC_STYLES = {
	html: {
		display: 'inline !important',
		overflow: 'hidden',
	},
	'.hydrated': {
		display: 'block',
		height: '48px',
		overflow: 'hidden',
	},
	input: {
		fontFamily: 'Graphik, Helvetica, sans-serif',
		color: '#000000',
		backgroundColor: '#FFFFFF',
		boxShadow: 'none',
		fontSize: '16px',
		height: '48px',
		width: '100%',
		padding: '11px 18px 11px 18px',
	},
	'.brand': {
		right: '8px',
		top: '8px',
	},
};

export { CC_STYLES };
